"use client";

import { useRouter } from "next/navigation";
import { SidebarStore } from "@/app/stores/SidebarStore";
import { UStyles } from "@/app/utils/UStyles";
import styles from "./Logo.module.css";

type Props = {
  max?: boolean;
  blinker?: boolean;
  className?: string;
};

export default function Logo(props: Props) {
  const { max = false, blinker = false, className = "" } = props;

  const router = useRouter();

  const closeSidebarOnMobile = SidebarStore((state) => state.closeSidebarOnMobile);

  return (
    <button
      className={UStyles.classNames(
        styles.logo,
        max ? styles.max : "",
        blinker ? styles.blinker : "",
        className,
      )}
      onClick={() => {
        closeSidebarOnMobile();
        router.push("/");
      }}
    >
      <svg viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#kliq_logo_clip)">
          <rect width="46" height="46" rx="8.15686" fill="black" />
          <g filter="url(#kliq_logo_blur)">
            <rect x="-3.05859" y="-4.07837" width="57.098" height="18.3529" fill="white" />
          </g>
          <g filter="url(#kliq_logo_shadow)">
            <path
              d="M13.9424 33V14.3887H17.7002V22.6533L25.292 14.3887H30.3447L23.3369 21.6377L30.7256 33H25.8633L20.7471 24.2656L17.7002 27.376V33H13.9424Z"
              fill="white"
            />
          </g>
        </g>
        <defs>
          <filter
            id="kliq_logo_blur"
            x="-37.2155"
            y="-38.2352"
            width="125.411"
            height="86.6667"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="17.0784" result="effect1_foregroundBlur" />
          </filter>
          <filter
            id="kliq_logo_shadow"
            x="9.94141"
            y="12.3887"
            width="24.7852"
            height="26.6113"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          </filter>
          <clipPath id="kliq_logo_clip">
            <rect width="46" height="46" rx="8.15686" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </button>
  );
}
